import {Endpoint} from '@eryxcoop/appyx-comm';

export default class MarkOrderAsInitialEndpoint extends Endpoint {

  adaptValues(orderNumber) {
    return {
      'order_number': orderNumber
    }
  }
}